import Insight from "../insightClass";
import React from "react";
import { insight13Media } from "../../../assets/assetReference";
import { ContactSubscribe } from "../../../components/Contact/Contact";
export const insight049 = new Insight(
  "06 June 2025",
  {
    pageTitle: "Global Offshore Wind Weekly",
    metaDescription: "WeBridge Insights, Global Offshore Wind Weekly",
    keyWords:
      "European Offshore Wind Market development, Global Offshore Wind Weekly",
  },
  {
    src: insight13Media[0],
    alt: "offshore wind turbine",
  },
  "Global Offshore Wind Weekly (2025-06-06)",
  "",
  `The UK government will open its seventh Contracts for Difference (CfD) auction round in August 2025, covering both fixed and floating offshore wind. Results are expected between December 2025 and February 2026.`,
  <div>
    <strong>WeBridge Insights</strong>
    <h1>Global Offshore Wind Weekly (2025-06-06)</h1>
    <h2></h2>
    <p className="article-date">06 June 2025</p>
    <br />
    <p>
      Welcome to this week's <i>WeBridge Insights</i>, where we provide you with
      the latest updates and key developments from the global offshore wind
      market.
    </p>
    <br />
    <br />
    <br />
    <p>
      At <b>WeBridge</b>, we deliver forward-thinking analysis and expert
      commentary to keep you informed in this fast-evolving industry. Here's our
      roundup of the top stories this week, complete with professional insights
      to help you stay ahead:
    </p>

    <h3>1. UK to Launch Seventh CfD Auction in August </h3>
    <p>
      The UK government will open its seventh Contracts for Difference (CfD)
      auction round in August 2025, covering both fixed and floating offshore
      wind. Results are expected between December 2025 and February 2026.
    </p>
    <p>
      <b>WeBridge Insights: </b>
    </p>
    <p>
      AR7 is pivotal for advancing the UK’s 2030 offshore wind targets. The
      inclusion of floating projects reflects technological progress. Developers
      will closely monitor strike prices, supply chain readiness, and government
      support mechanisms to determine bid viability.
    </p>
    <h3>2. 22 Offshore Wind Turbines Proposed off Cornwall Coast </h3>
    <p>
      A planning application has been submitted for 22 floating offshore wind
      turbines about 40 miles off Cornwall’s coast. The TwinHub project could
      generate up to 220 MW and is now under consultation.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      This marks a key step forward for floating wind in UK waters. TwinHub’s
      location in the Celtic Sea supports national ambitions to unlock deepwater
      resources. Public consultation outcomes may influence future floating
      developments across the region.
    </p>
    <h3>3. UK Peers Support Zonal Pricing Reform</h3>
    <p>
      UK lawmakers are backing reforms to create zonal electricity pricing,
      which could reduce consumer costs and improve efficiency by better
      reflecting local supply and demand, particularly in high-renewable areas.
    </p>
    <p>
      <b>WeBridge Insights: </b>
    </p>
    <p>
      Zonal pricing is a potential game-changer, offering clearer signals for
      offshore wind deployment. However, it requires robust modelling to avoid
      penalising less windy regions or introducing complexity for developers
      managing multiple assets across zones.
    </p>
    <h3>4. France’s Yeu-Noirmoutier Offshore Wind Farm Delivers First Power</h3>
    <p>
      Ocean Winds has delivered first power from the Îles d’Yeu and Noirmoutier
      wind farm. Initial turbines are now feeding electricity into France's
      national grid following test operations launched in late May.
    </p>
    <p>
      <b>WeBridge Insights: </b>
    </p>
    <p>
      This is a landmark for French offshore wind. The successful commissioning
      of this project demonstrates increasing maturity in French regulatory and
      grid coordination. It also highlights Ocean Winds’ capability in executing
      large-scale European projects.
    </p>
    <h3>
      5. Aker Solutions to Deliver Foundation for Germany's BalWin2 Offshore
      Grid Connection
    </h3>
    <p>
      Aker Solutions will deliver the substructure for a 2 GW HVDC converter
      platform as part of Germany’s BalWin2 offshore grid infrastructure. It
      will support large-scale wind transmission from the North Sea.
    </p>
    <p>
      <b>WeBridge Insights: </b>
    </p>
    <p>
      BalWin2 reflects Germany’s push to couple offshore wind expansion with
      critical transmission investments. Close coordination between generation
      and grid development is essential to prevent stranded assets and ensure
      energy security.
    </p>
    <h3>
      6. Copenhagen Energy and PGEC Advance 2 GW Project in the Philippines
    </h3>
    <p>
      Copenhagen Energy and PetroGreen Energy Corp are progressing a 2 GW
      floating wind project in Northern Luzon. It recently secured a grid
      connection, with two further 1 GW sites in planning.
    </p>
    <p>
      <b>WeBridge Insights: </b>
    </p>
    <p>
      This is a pioneering move in Southeast Asia. The Philippines shows strong
      offshore wind promise, but execution depends on continued regulatory
      clarity, investment incentives, and maritime infrastructure improvements.
    </p>
    <h3>7. Japan Passes Bill Allowing Offshore Wind Projects in EEZ</h3>
    <p>
      Japan has passed a law enabling floating wind development within its
      Exclusive Economic Zone, unlocking significant deepwater capacity and
      extending its renewable energy reach offshore.
    </p>
    <p>
      <b>WeBridge Insights: </b>
    </p>
    <p>
      Japan’s legislative shift creates major opportunities for floating wind
      developers. The key challenge will be to move from legislative permission
      to project pipeline reality—backed by investment, consenting frameworks,
      and local industrial participation.
    </p>

    <br />
    <br />
    <br />
    <p>
      As the global offshore wind sector continues to advance, innovation,
      investments, and supportive policies are driving transformative growth. At{" "}
      <i>
        <b>WeBridge</b>
      </i>
      , we provide the expertise and insights our partners need to confidently
      navigate this evolving landscape.
    </p>
    <h3 style={{ marginTop: "200px" }}>Subscribe</h3>
    <ContactSubscribe />
  </div>,
);
